enum VideoEvents {
    LoadVideoListStarted = "[VideoEvent] LoadVideoListStarted",
    LoadVideoListComplete = "[VideoEvent] LoadVideoListComplete",
    LoadVideoStarted = "[VideoEvent] LoadVideoStarted",
    LoadVideoComplete = "[VideoEvent] LoadVideoComplete",
    CreateStarted = "[VideoEvent] CreateStarted",
    CreateComplete = "[VideoEvent] CreateComplete",
    Update = "[VideoEvent] Update",
    Delete = "[VideoEvent] Delete",
    UploadExtraMaterials = "[VideoEvent] UploadExtraMaterials",
    UploadExtraMaterialsComplete = "[VideoEvent] UploadExtraMaterialsComplete",
    DeleteExtraMaterials = "[VideoEvent] DeleteExtraMaterials",
    // 視聴数カウント
    IncrementViewCount = "[VideoEvent] IncrementViewCount",
    // 視聴履歴登録
    AddViewingHistory = "[VideoEvent] AddViewingHistory",
    ReactStarted = "[VideoEvent] ReactStarted",
    ReactComplete = "[VideoEvent] ReactComplete",
    // コメントの追加
    AddVideoCommentStarted = "[VideoEvent] AddVideoCommentStarted",
    AddVideoCommentComplete = "[VideoEvent] AddVideoCommentComplete",
    // コメントの編集
    UpdateVideoCommentStarted = "[VideoEvent] UpdateVideoCommentStarted",
    UpdateVideoCommentComplete = "[VideoEvent] UpdateVideoCommentComplete",
    // コメントの削除
    DeleteVideoCommentStarted = "[VideoEvent] DeleteVideoCommentStarted",
    DeleteVideoCommentComplete = "[VideoEvent] DeleteVideoCommentComplete",
    // コメントの返信
    ReplayToVideoCommentStarted = "[VideoEvent] ReplayToVideoCommentStarted",
    ReplayToVideoCommentComplete = "[VideoEvent] ReplayToVideoCommentComplete",
    // videoをfilter
    filterVideoListStarted = "[VideoEvent] filterVideoListStarted",
    filterVideoListComplete = "[VideoEvent] filterVideoListComplete",
    // 新規Tag作成
    createNewTagStarted = "[VideoEvent] createNewTagStarted",
    createNewTagCompleted = "[VideoEvent] createTagComplete",
    createNewTagFailed = "[VideoEvent] createNewTagFailed",
    resetDuplicateError = "[VideoEvent] resetDuplicateError",
    // Tagリスト取得
    getTagListStarted = "[VideoEvent] getTagList",
    getTagListComplete = "[VideoEvent] getTagListComplete",
    // ビデオ追加
    AddVideoStarted = "[VideoEvent] AddVideo",
    AddVideoComplete = "[VideoEvent] AddVideoComplete",
    AddVideoFailed = "[VideoEvent] AddVideoFailed",
    // ビデオ編集
    EditVideoStarted = "[VideoEvent] EditVideo",
    EditVideoComplete = "[VideoEvent] EditVideoComplete",
    EditVideoFailed = "[VideoEvent] EditVideoFailed",
    // ビデオ資料アップロード
    UploadDocumentStarted = "[VideoEvent] UploadDocument",
    UploadDocumentComplete = "[VideoEvent] UploadDocumentComplete",
    UploadDocumentFailed = "[VideoEvent] UploadDocumentFailed",
    // ビデオ削除
    DeleteVideoStarted = "[VideoEvent] DeleteVideo",
    DeleteVideoComplete = "[VideoEvent] DeleteVideoComplete",
    DeleteVideoFailed = "[VideoEvent] DeleteVideoFailed",
    // ビデオデータリセット
    ResetVideos = "[VideoEvent] ResetVideos",
    ResetVideo = "[VideoEvent] ResetVideo",
    // ビデオスライド資料取得
    GetVideoSlide = "[VideoEvent] GetVideoSlide",
    GetVideoSlideComplete = "[VideoEvent] GetVideoSlideComplete",

    // ビデオスライド資料追加
    UploadVideoSlideStarted = "[VideoEvent] UploadVideoSlide",
    UploadVideoSlideFailed = "[VideoEvent] UploadVideoSlideFailed",
    UploadVideoSlideComplete = "[VideoEvent] UploadVideoSlideComplete",

    // ビデオスライド資料編集
    EditVideoSlideStarted = "[VideoEvent] EditVideoSlide",
    EditVideoSlideFailed = "[VideoEvent] EditVideoSlideFailed",
    EditVideoSlideComplete = "[VideoEvent] EditVideoSlideComplete",

    // ビデオスライド資料削除
    DeleteVideoSlideStarted = "[VideoEvent] DeleteVideoSlide",
    DeleteVideoSlideFailed = "[VideoEvent] DeleteVideoSlideFailed",
    DeleteVideoSlideComplete = "[VideoEvent] DeleteVideoSlideComplete",

    // 画面収録のビデオデータを一時保存
    SetMediaRecorderVideoFile = "[VideoEvent] SetMediaRecorderVideoFile",
    DeleteMediaRecorderVideoFile = "[VideoEvent] DeleteMediaRecorderVideoFile",

    // ローディング表示
    VisibleLoading = "[VideoEvent] VisibleLoading",
    InvisibleLoading = "[VideoEvent] InvisibleLoading",

    //統計ビデオ情報更新
    UpdateVideoStatistics = "[VideoEvent] UpdateVideoStatistics",
}

export default VideoEvents;
